import { render, staticRenderFns } from "./ButtonActions.vue?vue&type=template&id=5560d574&scoped=true&"
import script from "./ButtonActions.vue?vue&type=script&lang=js&"
export * from "./ButtonActions.vue?vue&type=script&lang=js&"
import style0 from "./ButtonActions.vue?vue&type=style&index=0&id=5560d574&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5560d574",
  null
  
)

export default component.exports